import { useContext } from "react";

import { GlobalFilterContext } from "@/shared/contexts/globalFilterContext";

export const useGlobalFilter = (): {
    policyholdersGF: number[];
    setPolicyholdersGF: (selection: number[]) => void;
    isProEnvironment?: boolean;
    setIsProEnvironment: (isPro: boolean) => void;
    removeGF: () => void;
} => {
    const context = useContext(GlobalFilterContext);
    return {
        policyholdersGF: context.policyholderGF,
        setPolicyholdersGF: context.updatePolicyholderGF,
        isProEnvironment: context.isProEnvironment,
        setIsProEnvironment: context.updateIsProEnvironment,
        removeGF: context.removeGF,
    };
};
